import { ArrowLeftIcon } from 'lucide-react'
import type { ReactNode } from 'react'

import { Button } from '@/components/ui/button'

interface AgencyDetailBackButtonProps {
  onClick: () => void
}

export const AgencyDetailBackButton = ({ onClick }: AgencyDetailBackButtonProps): ReactNode => (
  <Button variant="ghost" size="sm" className="agency-detail-back -ml-2 gap-2" onClick={onClick}>
    <ArrowLeftIcon className="size-4" />
    Back to agencies
  </Button>
)

AgencyDetailBackButton.displayName = 'AgencyDetailBackButton'
